import { forwardRef } from "react";
import { useValidation } from "@/shared/forms";
import type { NumberFieldProps } from "./types";

export const NumberField = forwardRef<HTMLInputElement, NumberFieldProps>(function NumberField(
    { id, ariaLabel, value, onChange, required = false, validationPattern = "number", customValidation, ...rest },
    ref,
) {
    useValidation(id, {
        errorLocation: "callout",
        rules: {
            required,
            year: validationPattern === "year",
            number: validationPattern === "number",
            ...(customValidation && { custom: customValidation }),
        },
    });

    return (
        <input
            id={id}
            type="number"
            value={value}
            onChange={onChange}
            required={required}
            aria-label={ariaLabel}
            ref={ref}
            {...rest}
        />
    );
});
